module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "listWrapper",
    staticClass: "company"
  }, [_c('div', {
    staticClass: "scroll-content"
  }, [(_vm.resultList.length) ? _c('j-pull', {
    attrs: {
      "refreshFunc": _vm.refreshFunc,
      "loadMore": _vm.loadMore
    }
  }, [_c('ul', {
    ref: "listUl",
    staticClass: "ui-list ui-list-text"
  }, _vm._l((_vm.resultList), function(list) {
    return _c('li', {
      key: list,
      staticClass: "ui-border-t"
    }, [_c('div', {
      staticClass: "ui-list-info"
    }, [_c('h4', {
      staticClass: "ui-nowrap"
    }, [_vm._v(_vm._s(list.enterpriseName))])]), _vm._v(" "), (list.hasNew) ? _c('div', {
      staticClass: "ui-new"
    }) : _vm._e()])
  }))]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73a929d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company.vue
// module id = 231
// module chunks = 1